function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function cleanAffectedLine(line) {
  return line
    .replace(/\[\(\s*\)\]/g, "")
    .replace(/\(\[\s*\]\)/g, "")
    .replace(/\[\s*\]/g, "")
    .replace(/\(\s*\)/g, "")
    .replace(/[ \t]{2,}/g, " ")
    .replace(/[ \t]+([,.;!?])/g, "$1")
    .trimEnd();
}

/**
 * Hides the URL represented by a rendered preview card without changing the
 * stored post content. Markdown link labels remain as non-clickable text.
 */
export function removeRenderedPreviewUrl(content = "", previewUrl = "") {
  const source = String(content || "");
  const url = String(previewUrl || "").trim();
  if (!source || !url || !source.includes(url)) return source;

  const escapedUrl = escapeRegExp(url);
  const markdownLink = new RegExp(
    `\\[([^\\]]+)\\]\\(\\s*<?${escapedUrl}>?(?:\\s+(?:"[^"]*"|'[^']*'))?\\s*\\)`,
    "g"
  );
  const angleLink = new RegExp(`<${escapedUrl}>`, "g");
  const rawLink = new RegExp(escapedUrl, "g");

  const cleaned = source
    .split(/\r?\n/)
    .map((line) => {
      if (!line.includes(url)) return line;
      return cleanAffectedLine(
        line.replace(markdownLink, "$1").replace(angleLink, "").replace(rawLink, "")
      );
    })
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

  return cleaned;
}
